/* eslint-disable prettier/prettier */
import { CheckCircle, Siren } from "@phosphor-icons/react";
import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  BoxText,
  ButtonContainer,
  Container,
  FiltersContainer,
  LabelBullet,
  Labels,
  LabelsContainer,
  Title,
} from "./styles";

import PrevixIcon from "../../assets/images/Surveillance/iconPrevix.svg";
import { Modal } from "../../components/Modal";
import { Button } from "../../components/common/Button";
import { DefaultContent } from "../../components/common/DefaultContent";
import { Input } from "../../components/common/Input";
import { Select } from "../../components/common/Select";
import { DateRangePickerComp } from "../../components/DateRangePicker";
import { ContextLatestRequests } from "../../context/context_latestRequests";
import { TableRequests } from "./components/TableRequests";
import MapOccurences from "./components/MapOccurences";
import MapTracking from "./components/MapTracking";
import { PanicOccurrenceSidebar } from "./components/PanicOccurrenceSidebar";
import { EscortOccurrenceSidebar } from "./components/EscortOccurrenceSidebar";
import { SuspectOccurrenceSidebar } from "./components/SuspectOccurrenceSidebar";
import { OccurrenceUserDetailsSidebar } from "./components/OccurrenceUserDetailsSidebar";
import { SecuritySelectionSidebar } from "./components/SecuritySelectionSidebar";
import api from "../../services/api";

import { Helmet } from "react-helmet";
import utils from "../../utils";
import { calculateDistance } from "../../utils/maps";

interface LocationProps {
  id: string;
  accuracy: string;
  altitude: string;
  latitude: number;
  longitude: number;
}

interface VehicleProps {
  id: string;
  vehicle: string;
  color: string;
  plate: string;
  type: string;
  interface: string;
}

interface BaseProps {
  id: string;
  base: string;
  outpost: string;
}

interface AddressProps {
  address: string;
  burgh: string;
  city: string;
  state: string;
  latitude: number;
  longitude: number;
  ResponsibleBase: BaseProps;
}

interface DurationProps {
  text: string;
  value: number;
}

interface OccurrenceProps {
  Occurrence: {
    id: string;
    name: string;
    code: string;
    type: string;
    status: string;
    additional_info: string;
    Base?: BaseProps;
    Location: LocationProps;
    created_at: string;
    updated_at: string;
    OccurrenceReview?: {
      id: string;
      id_user: string;
      id_employee: string;
      id_occurrence: string;
      rating: number;
      additional_info: string;
      created_at: string;
    }[];
  };
  Resident: {
    id_user: string;
    name: string;
    email: string;
    phone: string;
    // Base: BaseProps;
    Vehicle: VehicleProps[];
  };
  Employee?: {
    id: string;
    id_user: string;
    status: string;
    type: string;
    name: string;
    email: string;
    phone: string;
    Vehicle: VehicleProps[];
  };
  Vehicle?: VehicleProps;
  Address?: AddressProps;
  durationLocation: DurationProps;
  distanceLocation: DurationProps;
}

interface ISecurityInfo {
  id: string;
  Userinfo: {
  id: string;
  name: string;
    email: string;
    phone: string;
    Vehicle: {
      id: string;
      vehicle: string;
      color: string;
      plate: string;
      type: string;
    }[];
  };
  Employee: {
    id: string;
    status: string;
  };
  AlwaysAlert: string;
  UserDistance: {
    distance: {
      text: string;
    };
    duration: {
      text: string;
    };
  };
  OccurrenceDistance: {
    distance: {
      text: string;
    };
  };
  online: string;
  status: string;
}

export const LatestRequests = (placeholder = "Digite suas observações aqui...") => {
  const context = useContext(ContextLatestRequests);
  
  if (!context) {
    return <div>Loading...</div>;
  }

  const {
    occurrencesList,
    customersList,
    getCustomersList,
    getAllOccurrences,
    getSecuritiesList,
    securitiesList,
    triggerSecurity,
    setOccurrencesList,
    triggerSecuritySuccess,
    handleFilters,
    filter,
    setFilter,
    callFilteredOccurrences,
  } = context;

  const hours = Array.from({ length: 48 }, (_, index) => {
    const totalMinutes = index * 30;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const id = `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
    return {
      id,
      value: `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}`,
    };
  });

  const [isOccurrenceSidetabOpen, setIsOccurrenceSidetabOpen] = useState(false)
  const [occurrence, setOccurrence] = useState<OccurrenceProps>()
  const [observations, setObservations] = useState('')

  const [occurrenceUserDetails, setOccurrenceUserDetails] = useState<any>()
  const [isOccurrenceUserSidetabOpen, setIsOccurrenceUserSidetabOpen] =
    useState(false);
  const [isSecuritySidetabOpen, setIsSecuritySideTabOpen] = useState(false)
  const [securityRedirect, setSecurityRedirect] = useState(false)
  const [isModalSecurityRedirectOpen, setIsModalSecurityRedirect] = useState(false);
  const [isModalObservationOpen, setIsModalObservation] = useState(false);

  const [selectedSecurityId, setSelectSecurityId] = useState("")
  const [selectedSecurity, setSelectSecurity] = useState<ISecurityInfo>()

  const [baseMarkers, setBaseMarkers] = useState([])
  const [userMarkers, setUserMarkers] = useState([])
  const [employeeMarkers, setEmployeeMarkers] = useState([])

  const [timeDuration, setTimeDuration] = useState<any>();
  const [distanceLocation, setDistanceLocation] = useState<any>();
  const [dateRangeData, setDateRangeData] = useState(() => {
    const now = new Date();
    const startOfWeek = new Date(now);
    startOfWeek.setDate(now.getDate() - now.getDay()); // Start of week (Sunday)
    startOfWeek.setHours(0, 0, 0, 0);

    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6); // End of week (Saturday)
    endOfWeek.setHours(23, 59, 59, 999);

    return [{
      startDate: startOfWeek,
      endDate: endOfWeek,
      key: 'selection',
    }];
  });

  const handleCheckbox = (id) => {
    setSelectSecurityId(id);
    const security = securitiesList?.find((item) => item.id === id)
    setSelectSecurity(security);
  };

  const handleState = (setValue) => {
    setValue((prev) => !prev)
  };

  const getMapMarkers = () => {
    api.get("/v1/dashboard/surveillance/markers").then((response) => {
      const data = response.data
      setBaseMarkers(data.bases)
      setUserMarkers(data.users)
      setEmployeeMarkers(data.employees)
    });
  };



  const endOccurrenceHandler = () => {
    setTimeout(() => {
      api
        .put('/v1/app/security/occurrences/update', {
          id: occurrence?.Occurrence.id,
          id_employee: occurrence?.Employee?.id,
          status: 'FECHADO',
          additional_info: observations

        })
        .then(async (res) => {
          // console.log('FOIIII')
          // console.log("iddd", occurrence?.Occurrence.id)
          setIsModalObservation(true)
        })
        .catch((err) => {
          console.log("errooooo", err.response.data);
          // console.log("iddd", occurrence?.Occurrence.id)
          // console.log("employee iddd", occurrence?.Employee?.id)
        });
    }, 2000);
  };

  const handleObservationChange = (event) => {
    setObservations(event.target.value);
  };

  // Fetch occurrence duration data
  useEffect(() => {
    if (!occurrence?.Occurrence.id) return; // Aguarda occurrence ser preenchido

    const fetchOccurrenceDuration = async () => {
      try {
        // Only fetch duration for non-closed occurrences
        if (occurrence.Occurrence.status !== "Fechado") {
          const response = await api.post('/v1/dashboard/surveillance/tracking', {
            occurrenceId: occurrence.Occurrence.id,
          });
          setTimeDuration(response.data.durationLocation?.text || null);
          setDistanceLocation(response.data.distanceLocation?.text || null);
        } else {
          setTimeDuration(null);
          setDistanceLocation(null);
        }
      } catch (error) {
        console.error('Erro na requisição ou cálculo:', error);
        setTimeDuration(null);
        setDistanceLocation(null);
      }
    };

    fetchOccurrenceDuration();
  }, [occurrence])

  useEffect(() => {
    getMapMarkers()
    getCustomersList()
    callFilteredOccurrences(filter)

    // const getMapMarkersInterval = setInterval(() => {
    //   getMapMarkers()
    // }, 10000)

    const getCustomersListInterval = setInterval(() => {
      getCustomersList();
    }, 10000);

    const callFilteredOccurrencesInterval = setInterval(() => {
      console.log('filter', filter)
      callFilteredOccurrences(filter);
    }, 10000);

    return () => {
      // clearInterval(getMapMarkersInterval)
      clearInterval(getCustomersListInterval)
      clearInterval(callFilteredOccurrencesInterval);
    };
  }, [filter])

  // Initialize filter with default date range
  useEffect(() => {
    if (dateRangeData && dateRangeData.length > 0 && dateRangeData[0]) {
      handleFilters("start_date", dateRangeData[0].startDate.toISOString())
      handleFilters("end_date", dateRangeData[0].endDate.toISOString())
    }
  }, []) // Only run once on mount
  return (
    <>
      <Helmet>
        <title>Previx - Últimas ocorrências</title>
        <meta
          name="Previx - Últimas ocorrências"
          content="Página de últimas ocorrências"
        />
      </Helmet>

      <DefaultContent
        icon={<Siren size={26} color="#003E5F" />}
        title="Vigilância - Últimas ocorrências"
      >
        <Container>
          <Title>Mapa indicando localidade das ocorrências</Title>
          <Box padding="0">
            <MapOccurences
              baseLocationData={baseMarkers}
              userLocationData={userMarkers}
              employeeLocationData={employeeMarkers}
              setOccurrenceUserDetails={setOccurrenceUserDetails}
              openDetails={setIsOccurrenceUserSidetabOpen}
            />
          </Box>
          <Box>
            <LabelsContainer>
              <Title>Legenda:</Title>
              <Labels color="#003E5F">
                Sede da Previx
                <img src={PrevixIcon} alt="Previx Icon" />
              </Labels>
              <Labels color="#B00">
                {" "}
                <LabelBullet color="#B00" /> Moradores
              </Labels>
              <Labels color="#067FB7">
                <LabelBullet color="#067FB7" />
                Funcionários
              </Labels>
            </LabelsContainer>
          </Box>
          <Box>
            <FiltersContainer>
              <Title>Filtros de busca:</Title>
              <Select
                flex="1"
                onchange={
                  (e) => handleFilters("customer", e.target.value)
                  // setFilter((prev) => ({
                  //   ...prev,
                  //   customer: e.target.value,
                  // }))
                }
                label={{
                  title: "Clientes",
                  htmlFor: "",
                  color: "",
                  fontSize: "12px",
                }}
                data={customersList || []}
                padding="0.375rem 0.625rem"
                backgroundcolor=""
                bordercolor="#CECECE"
                currentOption={filter.customer}
                outlinecolor=""
              />
              <Select
                bordercolor="#CECECE"
                backgroundcolor="#f7f7f7"
                currentOption={filter.status}
                label={{ title: 'Status', htmlFor: '' }}
                onchange={(e) => {
                  handleFilters('status', e.target.value)
                }}
                data={[
                  { id: 'ABERTO', value: 'Aguardando ação' },
                  { id: 'EMPROGRESSO', value: 'Em ocorrência' },
                  { id: 'FECHADO', value: 'Encerrado' },
                ]}
              />
              <DateRangePickerComp
                dateRange={dateRangeData}
                setDateRange={(newDateRange) => {
                  setDateRangeData(newDateRange)
                  if (newDateRange && newDateRange.length > 0 && newDateRange[0]) {
                    handleFilters("start_date", newDateRange[0].startDate.toISOString())
                    handleFilters("end_date", newDateRange[0].endDate.toISOString())
                  }
                }}
              />
              <Select
                flex="1"
                onchange={(e) =>
                  setFilter((prev) => ({
                    ...prev,
                    start_hour: e.target.value,
                  }))
                }
                label={{
                  title: "Hora início",
                  htmlFor: "",
                  color: "",
                  fontSize: "12px",
                }}
                data={hours}
                padding="0.375rem 0.625rem"
                backgroundcolor=""
                bordercolor="#CECECE"
                currentOption={filter.start_hour}
                outlinecolor=""
              />
              <Select
                flex="1"
                onchange={
                  (e) => handleFilters("end_hour", e.target.value)
                  // setFilter((prev) => ({
                  //   ...prev,
                  //   end_hour: e.target.value
                  // }))
                }
                label={{
                  title: "Hora fim",
                  htmlFor: "",
                  color: "",
                  fontSize: "12px",
                }}
                data={hours}
                padding="0.375rem 0.625rem"
                backgroundcolor=""
                bordercolor="#CECECE"
                currentOption={filter.end_hour}
                outlinecolor=""
              />
              <ButtonContainer>
                <Button.Root
                  type="button"
                  backgroundColor="#003E5F"
                  onClick={() => {
                    callFilteredOccurrences(filter)
                  }}
                  padding=".6rem"
                >
                  <Button.Content title="Buscar" fontSize="12px" />
                </Button.Root>
              </ButtonContainer>
            </FiltersContainer>
          </Box>
          <Title>
            Listando{" "}
            {occurrencesList?.length !== 0 ? occurrencesList?.length : "0"}{" "}
            ocorrências (todas ocorrências){" "}
          </Title>
          <Box>
            <TableRequests
              data={occurrencesList || []}
              getOccurrence={setOccurrence}
              openDetails={() => {
                handleState(setIsOccurrenceSidetabOpen)
              }}
            />
          </Box>

          {occurrence ? (
            <>
              {occurrence.Occurrence.type === "Pânico" && (
                <PanicOccurrenceSidebar
                  occurrence={occurrence}
                  isOpen={isOccurrenceSidetabOpen}
                  onClose={() => handleState(setIsOccurrenceSidetabOpen)}
                  timeDuration={timeDuration}
                  distanceLocation={distanceLocation}
                  onTriggerSecurity={() => {
                    handleState(setIsSecuritySideTabOpen);
                    getSecuritiesList(
                      occurrence.Occurrence.id,
                      occurrence.Occurrence.Base?.id || ""
                    );
                  }}
                  isSecuritySideTabOpen={isSecuritySidetabOpen}
                />
              )}
              {occurrence.Occurrence.type === "Escolta" && (
                <EscortOccurrenceSidebar
                  occurrence={occurrence}
                  isOpen={isOccurrenceSidetabOpen}
                  onClose={() => handleState(setIsOccurrenceSidetabOpen)}
                  timeDuration={timeDuration}
                  distanceLocation={distanceLocation}
                  onTriggerSecurity={() => {
                            handleState(setIsSecuritySideTabOpen);
                            getSecuritiesList(
                              occurrence.Occurrence.id,
                      occurrence.Occurrence.Base?.id || ""
                            );
                          }}
                  isSecuritySideTabOpen={isSecuritySidetabOpen}
                />
              )}
              {occurrence.Occurrence.type === "Suspeita" && (
                <SuspectOccurrenceSidebar
                  occurrence={occurrence}
                  isOpen={isOccurrenceSidetabOpen}
                  onClose={() => handleState(setIsOccurrenceSidetabOpen)}
                  observations={observations}
                  onObservationChange={handleObservationChange}
                  onEndOccurrence={endOccurrenceHandler}
                />
              )}
            </>
          ) : null}

          {occurrenceUserDetails ? (
            <OccurrenceUserDetailsSidebar
              occurrenceUserDetails={occurrenceUserDetails}
              isOpen={isOccurrenceUserSidetabOpen}
              onClose={() => handleState(setIsOccurrenceUserSidetabOpen)}
              securityRedirect={securityRedirect}
              onTriggerSecurity={() => {
                      handleState(setIsSecuritySideTabOpen);
                      getSecuritiesList(
                  occurrenceUserDetails.Occurrence?.id || "",
                  occurrenceUserDetails.Resident?.Base?.id || ""
                      );
                    }}
                    />
          ) : null}
          <SecuritySelectionSidebar
            isOpen={isSecuritySidetabOpen}
            onClose={() => {
                handleState(setIsSecuritySideTabOpen);
                setSelectSecurity(undefined);
                setSelectSecurityId("");
              }}
            securitiesList={securitiesList}
            selectedSecurityId={selectedSecurityId}
            selectedSecurity={selectedSecurity}
            onCheckboxChange={handleCheckbox}
            onTriggerSecurity={() => {
              occurrence && triggerSecurity(
                          occurrence,
                selectedSecurity?.Employee?.id || ""
                        );
                        setIsModalSecurityRedirect(true);
                      }}
            occurrence={occurrence}
          />
          
          <Modal.Root
            backgroundcolor="#fff"
            borderradius="6px"
            width="30%"
            height="fit-content"
            left="50%"
            top="50%"
            open={isModalSecurityRedirectOpen}
            setIsOpenController={() => {
              location.reload();
            }}
            padding="0 0 1rem 0"
          >
            <Modal.Header onclick={() => location.reload()} />
            <Modal.Icon icon={<CheckCircle size={48} fill="#006598" />} />
            <Modal.Content
              value="Segurança redirecionado!"
              subvalue="As informações e ações foram passadas
            para o aplicativo do segurança e informamos
            também o usuário com uma atualização no caso."
            />
            <Modal.Footer>
              <Button.Root
                type="button"
                backgroundColor="#00517D"
                onClick={() => {
                  handleState(setIsModalSecurityRedirect);
                  handleState(setIsSecuritySideTabOpen);
                  handleState(setSecurityRedirect);
                  location.reload();
                }}
              >
                <Button.Content title="Voltar para página" fontSize="12px" />
              </Button.Root>
            </Modal.Footer>
          </Modal.Root>
          <Modal.Root
            backgroundcolor="#fff"
            borderradius="6px"
            width="30%"
            height="fit-content"
            left="50%"
            top="50%"
            open={isModalObservationOpen}
            setIsOpenController={() => {
              location.reload();
            }}
            padding="0 0 1rem 0"
          >
            <Modal.Header onclick={() => location.reload()} />
            <Modal.Icon icon={<CheckCircle size={48} fill="#006598" />} />
            <Modal.Content
              value="Ocorrência finalziada!"

            />
            <Modal.Footer>
              <Button.Root
                type="button"
                backgroundColor="#00517D"
                onClick={() => {
                  handleState(setIsModalObservation);
                  location.reload();
                }}
              >
                <Button.Content title="Voltar para página" fontSize="12px" />
              </Button.Root>
            </Modal.Footer>
          </Modal.Root>
        </Container>
      </DefaultContent>
    </>
  );
};
